import React from 'react';

interface Props {
    mapsLink: string;
	mapItTitle: string;
}

export function MapItAction(props: Props){
	const { mapsLink, mapItTitle } = props;
	
	if (!mapsLink) return null;

	return (<a href={mapsLink} target='_blank' rel="noreferrer">{ mapItTitle || 'Map it'}</a>);
}